@if (!hideToolbar()) {

  <div class="toolbar-row row justify-content-between align-items-center">

    <div [class.mb-3]="!isLoading()" class="col-total col-12 col-md-auto mb-md-0">
      @if (!isLoading()) {
        <ng-container i18n>Знайдено {{ total() | plural: EV_PLURALS }}</ng-container>
      }
    </div>

    <div class="col-12 col-md-auto d-flex flex-row align-items-center">

      <div class="sort-wrapper d-flex flex-column flex-md-row align-items-start align-items-md-center">
        <label for="sort" class="form-label d-inline-flex me-0 me-md-2" i18n>Сортування:</label>
        <select id="sort" [formControl]="sortControl" class="sort-select form-select">
          @for (option of sortOptions(); track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>

      <div class="view-btn-group btn-group d-none d-lg-inline-flex" role="group">
        <button (click)="setView('grid')" [class.active]="view() === 'grid'" type="button"
                class="btn btn-outline-secondary" title="Сітка" i18n-title>
          <mat-icon svgIcon="sax:linear-grid-1"></mat-icon>
        </button>
        <button (click)="setView('list')" [class.active]="view() === 'list'" type="button"
                class="btn btn-outline-secondary" title="Список" i18n-title>
          <mat-icon svgIcon="sax:linear-grid-6"></mat-icon>
        </button>
      </div>

    </div>

  </div>
}

@if (isUpdating() || isLoading()) {

  <evland-section-loader hideLabel="true"></evland-section-loader>

} @else {

  @switch (view()) {

    @case ('grid') {

      <div class="row card-grid">

        @for (car of cars(); track car.id) {

          <div [class.col-md-6]="columns() > 1" [class.col-xl-4]="columns() > 2" class="col-12">

            <evland-car-card [car]="car"></evland-car-card>

          </div>

        }

      </div>

    }
    @case ('list') {

      <div class="d-flex flex-column">

        @for (car of cars(); track car.id; let last = $last) {

          <evland-car-row [car]="car" [isLast]="last"></evland-car-row>

        }

      </div>

    }
  }

}
